<template>
  <div class="ui container view">
    <div class="ui two column centered grid">
      <div class="column">
        <div class="ui raised segment">
          <div v-if="flashIsActive" v-bind:class="flash.type" class="ui message">
            <div class="header">
              {{ flash.type | capitalize }}
            </div>
            <p>{{ flash.message }}</p>
          </div>
          <div v-else class="ui icon message">
            <i class="notched circle loading icon"></i>
            <div class="content">
              <div class="header">
                Just one second
              </div>
              <p>Loading the quote for you right now...</p>
            </div>
          </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  computed: {
    quoteIsLoaded () {
      return this.$store.getters.quoteIsLoaded
    },

    flash () {
      return this.$store.getters.flash
    },

    flashIsActive () {
      return this.$store.getters.flashIsActive
    }
  },

  watch: {
    quoteIsLoaded () {
      if (this.quoteIsLoaded) {
        this.$router.push({ name: 'dashboard' })
      }
    }
  },

  methods: {
    loadQuote () {
      if (!_.isEmpty(this.$route.query.id)) {
        let quoteId = this.$route.query.id
        this.$store.commit('SET_AUTH_TOKEN', this.$route.query.auth_token)
        this.$store.dispatch('loadQuote', quoteId)
      } else {
        this.$store.commit('SET_FLASH', {
          type: 'error',
          message: 'Unable to load the quote because the Quote ID is missing...'
        })
      }
    }
  },

  mounted () {
    this.loadQuote()
  }
}
</script>



// WEBPACK FOOTER //
// Edit.vue?0598c9be